import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {Role} from './common/enums'
import{UILayoutComponent} from './_layout/ui-layout/ui-layout.component'
import{DashboardComponent} from '../../src/app/modules/user/dashboard/dashboard.component'
import{ResultsComponent} from '../app/modules/user/results/results.component';
import{SigninComponent} from '../app/modules/admin/signin/signin.component'
import{AdminLayoutComponent} from '../app/_layout/admin-layout/admin-layout.component'
import{AdminDashboardComponent} from '../app/modules/admin/admin-dashboard/admin-dashboard.component'
import {SystemSettingsComponent} from '../app/modules/admin/system-settings/system-settings.component';
import { AccessibilityComponent } from './modules/user/accessibility/accessibility.component';
import { PrivacypolicyComponent } from './modules/user/privacypolicy/privacypolicy.component';
import { TermsOfUseComponent } from './modules/user/terms-of-use/terms-of-use.component';
import { ContactusComponent } from './modules/user/contactus/contactus.component';
import { FaqComponent } from './modules/user/faq/faq.component';
// import { GooglemapsComponent } from './modules/user/googlemaps/googlemaps.component';
import { SendrequestComponent } from './modules/user/sendrequest/sendrequest.component';
import { ProvidersearchComponent } from './modules/user/providersearch/providersearch.component';

const routes: Routes = [

  {path:'',component: UILayoutComponent,
  children: [
    {path:'',component: DashboardComponent},
    {path:'dashboard',component: DashboardComponent},
    {path:'results',component:ResultsComponent},
    {path:'providersearch',component:ProvidersearchComponent},
    {path:'accessibility',component:AccessibilityComponent},
    {path:'privacypolicy',component:PrivacypolicyComponent},
    {path:'termsofuse',component:TermsOfUseComponent},
    {path:'contactus',component:ContactusComponent},
    {path:'faq',component:FaqComponent},
    {path:'sendrequest',component:SendrequestComponent},
  ]
  
},
// {path:'googlemaps/:lat/:long',component:GooglemapsComponent},
// {path:'googlemaps/:address/:lat/:long',component:GooglemapsComponent},
// ,
// {path:'admin',component: AdminLayoutComponent,
// data: { roles: [Role.Admin] },
// children: [
//   {path:'dashboard',component:AdminDashboardComponent},
//   {path:'systemsettings',component:SystemSettingsComponent}
// ]
// },
// {path:'signin',component:SigninComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
